import {useContext} from 'react'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal from '@s-ui/react-molecule-modal'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import Icon from '@adv-mt/mt-svg-icons/lib/FileShieldOutline.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

const getModalChildren = ({i18n}) => {
  return (
    <div className="mt-TransactionSellerDeliveryKoReasonsModal-modalChildren">
      <div className="mt-TransactionSellerDeliveryKoReasonsModal-description">
        {i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TEXT_PARAGRAPH_1')}
      </div>
      <div className="mt-TransactionSellerDeliveryKoReasonsModal-description">
        {htmlStringToReactElement(
          i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TEXT_PARAGRAPH_2', {
            highlightStart: '<strong>',
            highlightEnd: '</strong>'
          })
        )}
      </div>
      <div className="mt-TransactionSellerDeliveryKoReasonsModal-description">
        {i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TEXT_PARAGRAPH_3')}
      </div>
      <div className="mt-TransactionSellerDeliveryKoReasonsModal-contentWrapper mt-TransactionSellerDeliveryKoReasonsModal-contentWrapper--withIcon">
        <div className="mt-TransactionSellerDeliveryKoReasonsModal-contentIcon">
          <Icon size={ATOM_ICON_SIZES.medium} />
        </div>
        <div className="mt-TransactionSellerDeliveryKoReasonsModal-contentText">
          <div className="mt-TransactionSellerDeliveryKoReasonsModal-contentTextTitle">
            {i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TEXT_BOX_TITLE')}
          </div>
          <span>
            {htmlStringToReactElement(
              i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TEXT_BOX', {
                highlightStart: '<strong><u>',
                highlightEnd: '</u></strong>'
              })
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

export const SellerDeliveryKoReasonsTransactionModal = () => {
  const {domain, i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const urlStaticsImages = domain.get('config').get('URL_STATICS_IMAGES')

  const imageUrl = `${urlStaticsImages}illustrations/buyer-customer-care.svg`

  return (
    <MoleculeModal
      isOpen={true}
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
    >
      <div className="mt-TransactionSellerDeliveryKoReasonsModal-modalContainer">
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD')
                }
              },
              children: getModalChildren({i18n}),
              headerImage: (
                <div className="mt-TransactionModal-contentHeaderImageWrapper">
                  <AtomImage
                    alt={i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TITLE')}
                    className="mt-TransactionModal-contentHeaderImage"
                    src={imageUrl}
                  />
                </div>
              ),
              title: i18n.t('VEHICLE_TRANSACTION.SELLER_DELIVERY_KO_REASONS_MODAL.TITLE'),
              titleMarginBottom: 'l'
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}
